import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiDollarSign, FiDisc, FiMapPin, FiShoppingBag, FiTag } = FiIcons;

const TYPES = {
  revenue_share: { label: 'Revenue Share', icon: FiDollarSign, color: 'text-green-400',  bg: 'bg-green-500/10 border-green-500/20' },
  co_release:    { label: 'Co-Release',    icon: FiDisc,       color: 'text-blue-400',   bg: 'bg-blue-500/10 border-blue-500/20' },
  tour:          { label: 'Tour',          icon: FiMapPin,     color: 'text-orange-400', bg: 'bg-orange-500/10 border-orange-500/20' },
  merch:         { label: 'Merch',         icon: FiShoppingBag,color: 'text-pink-400',   bg: 'bg-pink-500/10 border-pink-500/20' },
  label_deal:    { label: 'Label Deal',    icon: FiTag,        color: 'text-purple-400', bg: 'bg-purple-500/10 border-purple-500/20' },
};

const PartnershipTypeTag = ({ type, size = 'sm' }) => {
  const t = TYPES[type] || TYPES.co_release;
  const textSize = size === 'lg' ? 'text-xs' : 'text-[10px]';
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border font-black uppercase tracking-widest ${textSize} ${t.bg} ${t.color}`}>
      <SafeIcon icon={t.icon} className="text-xs" />
      {t.label}
    </span>
  );
};

export default PartnershipTypeTag;